export var EmailTemplateStatus;
(function (EmailTemplateStatus) {
    EmailTemplateStatus[EmailTemplateStatus["Draft"] = 1] = "Draft";
    EmailTemplateStatus[EmailTemplateStatus["Published"] = 2] = "Published";
    EmailTemplateStatus[EmailTemplateStatus["Archived"] = 3] = "Archived";
})(EmailTemplateStatus || (EmailTemplateStatus = {}));
